import { Link, NavLink, Outlet } from "react-router";
import { primaryNavRoutes } from "../routes/routeConfig";

export function AppLayout() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-950">
      <div className="mx-auto grid max-w-[1440px] gap-5 p-6 lg:grid-cols-[260px_1fr]">
        <aside className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm lg:sticky lg:top-6 lg:h-[calc(100vh-3rem)]">
          <Link to="/" className="flex items-center gap-3 no-underline">
            <div className="grid size-12 place-items-center rounded-xl border border-slate-300 bg-slate-100 font-black text-slate-950">VX</div>
            <div><strong className="block">Violet Exchange</strong><span className="text-sm text-slate-500">Independent P2P marketplace</span></div>
          </Link>
          <div className="mt-8 text-xs font-black uppercase tracking-[.22em] text-slate-500">Product surfaces</div>
          <nav className="mt-3 grid gap-1">
            {primaryNavRoutes.map(route => <NavLink key={route.path} to={route.path} className={({ isActive }) => `rounded-xl px-3 py-2 text-sm font-semibold ${isActive ? "bg-slate-950 text-white" : "text-slate-600 hover:bg-slate-100 hover:text-slate-950"}`}>{route.label}</NavLink>)}
          </nav>
          <div className="mt-8 rounded-xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-600">
            <strong className="mb-3 block text-slate-950">Production app scaffold</strong>
            <div className="flex justify-between border-b border-slate-200 py-2"><span>Runtime</span><b>Bun + React</b></div>
            <div className="flex justify-between border-b border-slate-200 py-2"><span>Styling</span><b>Tailwind</b></div>
            <div className="flex justify-between py-2"><span>Mode</span><b>Live backend</b></div>
          </div>
        </aside>
        <main className="min-w-0"><Outlet /></main>
      </div>
    </div>
  );
}
